module.exports = __webpack_public_path__ + "static/img/40020 (4).b331b54.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40020 (4).webp
// module id = /JSJ
// module chunks = 14